<template>
  <v-container fluid class="pa-0">
    <div class="flex w-full">
      <div v-if="!isMobile || centerV" class="w-full  sm:w-1/2 xs:w-1/2" :class="`${routeLink}_centerGradient`">
        <v-row justify="center" align-content="center" no-gutters>
          <v-col cols="12">
            <div class="flex justify-center">
              <v-avatar tile height="100" width="150" class="my-2">
                <img class="" :src="require('@/assets/img/Logo/logo.gif')" />
              </v-avatar>
            </div>
          </v-col>
          <v-col cols="12" class="overflow-y-auto">
            <NoCompSelected type="notification" v-if="!notificationSelector" />
            <span v-else>
              <router-view name="middleSection"> </router-view>
            </span>
          </v-col>
        </v-row>
      </div>
      <div class="grid w-full h-screen place-items-center xs:w-1/2 sm:w-1/2 xs:grid" v-if="!isMobile || rightV">
        <div class="rounded-none w-full h-screen xs:h-min xs:rounded-[0px_30px_30px_0px]"
          :class="`${routeLink}_sideGradient`">
          <v-row class="py-7 ma-0 align-end">
            <span class="py-0 pl-10 !w-min">
              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-badge overlap right bottom :color="colorAsRoute" icon="mdi-help" dark bordered>
                    <v-icon size="50" color="white" v-bind="attrs" v-on="on">
                      mdi-bell-ring-outline
                    </v-icon>
                  </v-badge>
                </template>
                <span :class="`${colorAsRoute}_fortext`">Your notifications</span>
              </v-tooltip>
            </span>
            <v-col class="py-0 pl-3">
              <h2 class="text-4xl font-Handel">Notifications</h2>
            </v-col>
          </v-row>
          <div class="hr2"></div>
          <v-row justify="space-between" no-gutters>
            <v-col class="xs:pl-10 pl-5 pt-3 pr-3 overflow-y-auto h-[75vh]  !rounded-br-[30px]">
              <LoadingSpinner v-if="notificationsLoading" class="bg-transparent !relative !top-1/2 -translate-y-1/2" />
              <v-list-item dark
                class="mb-5 py-4 mx-4 justify-center !max-h-[80px] gray rounded-lg black red_list font-Handel text-center"
                v-else-if="notifications.length < 1">
                No Notifications Available
              </v-list-item>
              <v-list v-else class="text-white transparent font-Handel !max-w-[540px] !w-[340px] !min-w-full">
                <v-list-item dark v-for="( notification , idx ) in notifications" :key="notification.nid" :to="{
                  name: 'SingleNotification',
                  params: { id: notification.nid },
                }" v-motion :initial="{ opacity: 0, y: 100 }" :enter="{
  opacity: 1, y: 0, transition: {
    duration: 400,
    type: 'keyframes',
    ease: 'backInOut',
    delay: `${idx}00`,
  },
}"
                  :class="`mb-5 listBG ${routeLink}-border !border-2 !border-black before:!opacity-0 ${notification.read_at == null ? `${routeLink}_box-shadow` : ''}`"
                  @click.prevent="setCenterView">
                  <!-- :class="`${notification.read_at == null ? `${routeLink}_box-shadow` : ''}`" -->
                  <!-- this will be used when notification read will work -->
                  <v-list-item-icon class="mr-3">
                    <v-avatar size="50">
                      <v-img class="!border-2 " v-if="notification.data.user_image" position="top center"
                        :class="`${routeLink}-border`" :src="`${notification.data.user_image}`" alt="" />
                      <v-img class="!border-2 " v-else :class="`${routeLink}-border`" position="top center"
                        :src="require('@/assets/fav_icon/android-chrome-512x512.png')" alt="" />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="">
                      {{ notification.data.subject }}</v-list-item-title>
                    <v-list-item-subtitle class="">{{
                      notification.data.message
                    }} Lorem ipsum dolor, sit amet consectetur adipisicing elit. Praesentium, deserunt odit, ipsam
                      alias expedita voluptatibus magnam mollitia a eaque atque vero eius. Alias harum illum earum
                      accusantium ullam commodi repellendus.</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content class="max-w-[70px] !text-xs">
                    <span class="">{{ notification.time }}</span>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import NoCompSelected from "../../../../components/noselection/NoCompSelected.vue";
import LoadingSpinner from '@/pages/front/straight/childs/LoadingSpinner.vue';

import axios from "axios";
export default {
  components: {
    NoCompSelected,
    LoadingSpinner
  },
  data() {
    return {
      notifications: [],
      notificationsLoading: false

    };
  },
  methods: {
    async getNotifications() {
      try {
        this.notificationsLoading = true;
        const resp = await axios.get('user-notifications')
        // console.log(JSON.parse(resp.data.data[0].data))
        this.notifications = resp.data.data
        this.notifications.map((i) => { const data = JSON.parse(i.data); i.data = data; i.date = new Date(i.created_at).toLocaleDateString(); i.time = new Date(i.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }); })


        // console.log(resp.data.data)
      } catch (error) {
        console.log(error, "~from single notification")
      } finally {
        this.notificationsLoading = false;
      }
    }
  },
  computed: {
    notificationSelector() {
      return this.$route.params.id ? true : false;
    },
    colorAsRoute() {
      if (this.routeLink == 'straight') {
        return '#a07a1d'
      }
      else if (this.routeLink == 'gay') {
        return '#88c3fa'
      }
      else if (this.routeLink == 'lesbian') {
        return '#9e2eec'
      }
    },
  },
  created() {
    this.getNotifications();
  },

};
</script>

<style scoped>
.listBG {
  background-color: #000000;
  border-radius: 15px;
}

.logo {
  width: 30%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 30px;
}

.timeFloater {
  position: absolute;
  top: 5%;
  right: 2%;
}

.straight_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(335deg,
      rgb(136 97 0) 0%,
      rgb(255 223 153) 53%,
      rgb(130 93 0 / 97%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gay_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(357deg,
      rgba(0, 240, 255, 1) 55%,
      rgba(0, 156, 255, 1) 75%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_centerGradient {

  background: rgb(59, 0, 68);
  background: linear-gradient(163deg, rgb(37 0 42) 0%, rgb(87 1 133) 38%, rgba(130, 5, 197, 1) 100%);
  position: relative;
  z-index: 1;

}

.gay_centerGradient {
  background: rgb(1, 2, 4);
  background: -moz-linear-gradient(174deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
  background: -webkit-linear-gradient(174deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
  background: linear-gradient(174deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#009bff", GradientType=1);
}

.straight_centerGradient {

  background: rgb(1, 2, 4);
  background: -moz-linear-gradient(171deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
  background: -webkit-linear-gradient(171deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
  background: linear-gradient(171deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#837045", GradientType=1);

}

.lesbian_sideGradient {

  background: rgb(59, 0, 68);
  background: linear-gradient(90deg, rgb(37 0 42) 0%, rgb(87 1 133) 38%, rgba(130, 5, 197, 1) 100%);
  position: relative;
  z-index: 1;

}

.gay_sideGradient {
  background: rgb(1, 2, 4);
  background: -moz-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
  background: -webkit-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
  background: linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(0, 107, 177, 1) 46%, rgba(0, 155, 255, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#009bff", GradientType=1);
}

.straight_sideGradient {

  background: rgb(1, 2, 4);
  background: -moz-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
  background: -webkit-linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
  background: linear-gradient(90deg, rgba(1, 2, 4, 1) 0%, rgba(97, 87, 64, 1) 46%, rgba(131, 112, 69, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#010204", endColorstr="#837045", GradientType=1);

}

.straight-border {
  border-color: #a07a1d;
}

.gay-border {
  border-color: #88c3fa;
}

.lesbian-border {
  border-color: #9e2eec;
}

.straight_box-shadow {
  box-shadow: 0px 0px 20px 0 #f6c44dd6 !important;
  border: 2px solid #f6c44dd6;

}

.lesbian_box-shadow {
  box-shadow: 0px 0px 20px 0 #9e2eec !important;
  border: 2px solid #9e2eec;

}

.gay_box-shadow {
  box-shadow: 0px 0px 10px 0 #88c3fa !important;
  border: 2px solid #88c3fa;
}

.straight-border.v-list-item--active {
  border-color: #a07a1d !important;
}

.gay-border.v-list-item--active {
  border-color: #88c3fa !important;
}

.lesbian-border.v-list-item--active {
  border-color: #9e2eec !important;
}
</style>
